export default __webpack_public_path__ + "static/media/13.a2f141ee.png";